var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCheckError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 2.00771C5.40667 2.00771 2.008 5.40637 2.008 9.59971C2.008 13.793 5.40667 17.1917 9.6 17.1917C13.7933 17.1917 17.192 13.793 17.192 9.59971C17.192 5.40637 13.7933 2.00771 9.6 2.00771ZM9.6 -0.000291824C14.9013 -0.000291824 19.2 4.29837 19.2 9.59971C19.2 14.9024 14.9013 19.1997 9.6 19.1997C4.29867 19.1997 0 14.9024 0 9.59971C0 4.29837 4.29867 -0.000291824 9.6 -0.000291824Z",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCheckError);
export default __webpack_public_path__ + "static/media/no_check_error.66fe846471153b7bc9c032bc38a11142.svg";
export { ForwardRef as ReactComponent };